import Vue from "vue";
import Router from "vue-router";
import routes from "@/router/routes/public.js";
import { trackPageView } from "@/utils/analytics";

Vue.use(Router);

let router = new Router({
    mode : "history",
    routes: [
    {
        path: "/",
        name: "Home"
    }
    ].concat(routes)
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    if(to.path == '/') {
        // Keep the query and hash: campaign tags on a link to the homepage
        // must survive this redirect.
        return next({
            path: "/homepage",
            query: to.query,
            hash: to.hash
        });
    }else{
        next();
    }

});

// One page view per navigation, sent by us rather than by Google so the
// address is cleaned first. The short wait lets vue-meta set the new title.
// trackPageView sends nothing without analytics consent (nor while
// scripts/prerender.js renders pages, which runs with no consent).
router.afterEach(() => {
    setTimeout(trackPageView, 100);
});

export default router;
